export const environment = {
  production: true,
  base_url: ' https://uat-api.xploraluxe.com/user/api/v1/',
  admin_url: ' https://uat-api.xploraluxe.com/admin/api/v1/',
  operational_url:'https://uat-api.xploraluxe.com/operational/api/v1/',
  image_url:'https://uat-api.xploraluxe.com/common/api/v1/upload/uploadDoc',
  blogs_url: '',
  rememberMeKey: 'XPW_RM_K_P',
  googleKey: 'AIzaSyDIZwbQqi5J9a7DAHuTGs8_zbKK6by891s',
  storageKey: 'XPW_ST_K_P',
  port: '9090',
  langKey: 'Lang',
  guestId: 'guestId',
  googleClientId: '519092807132-qjq6gfk1j13j9lc5jllorh4rh3aq341m.apps.googleusercontent.com',
  facebookAppId: '853599353332981',
  firebaseConfig: {
    apiKey: 'AIzaSyDh0KHjv2UtKo7J0njr5-O5E6hmhUJgXHk',
    authDomain: 'xplora-luxe.firebaseapp.com',
    projectId: 'xplora-luxe',
    storageBucket: 'xplora-luxe.firebasestorage.app',
    messagingSenderId: '768184676302',
    appId: '1:768184676302:web:80f1bbf0f164bcc539059f',
    measurementId: 'G-9ZHR95PGGC',
    vapidKey: 'BPd8igfMKQ7A5D82bBCi1_xFrv3Rf5ZmcCMatUPbO7tWE-Mlhh9CyzgVwnK6E_eWy2lo3f89nzfmDfpG1QdF82s'
  },
  path: '/firebase-messaging-sw.js',
  scope: './',
   baseCurrency: 'AED',
  exchangeRates: {
    AED: 1,
    USD: 0.27225 
  }
};
